import { ApplicationInsights, IEventTelemetry } from '@microsoft/applicationinsights-web';
import { nonProduction } from '.';

const trackEvent = (event: IEventTelemetry) => {
    const windowAsAny = window as any;
    const appInsights: ApplicationInsights | null = nonProduction ? null : windowAsAny.appInsights;

    try {
        appInsights?.trackEvent(event);
    } catch (e) { }
};


export const track = (name: string, properties: Record<string, unknown>) => trackEvent({ name: name, properties });
